import { DISTRIBUTOR } from '@autopass-web/domain';

import autoPartnerMethods from './auto-partner/methods';
import autoPartnerParams from './auto-partner/params';
import mochiClientMethods from './mochi-client/methods';
import mochiClientParams from './mochi-client/params';
import richartLifeMethods from './richart-life/methods';
import richartLifeParams from './richart-life/params';
import uatMethods from './uat/methods';
import uatParams from './uat/params';

/** @deprecated */
const distributorGroup = {
  [DISTRIBUTOR.CATHAYMR]: {
    params: mochiClientParams,
    methods: mochiClientMethods,
  },
  [DISTRIBUTOR.AUTO_PARTNER]: {
    params: autoPartnerParams,
    methods: autoPartnerMethods,
  },
  [DISTRIBUTOR.RICHART_LIFE]: {
    params: richartLifeParams,
    methods: richartLifeMethods,
  },
  [DISTRIBUTOR.UAT]: {
    params: uatParams,
    methods: uatMethods,
  },
};
export default distributorGroup;
